import classNames from 'classnames'
import { generateSrcSet } from 'project/image-proxy-web'
import { FC } from 'react'

type PartnerTestimonialCardProps = {
  reviewer: string
  designation: string
  review: string
  logo: string
  alt: string
  textSize?: 'normal' | 'large'
}

type Props = {
  tideReview?: string
  annaReview?: string
  textSize?: 'normal' | 'large'
}

const ukTestimonials = {
  anna: 'Adding a virtual office address to our company formation service makes it faster and easier than ever for entrepreneurs to set up their business and get started. A virtual office address helps protect personal information while maintaining a professional image. With the growing trend of working from home, we anticipate even greater demand for this convenient and secure solution.',
  tide: '"Incorporating a virtual office address service into our company formation offering means Tide now makes it quicker and easier than ever for people to register a business and get themselves up and running. Having a virtual office address allows entrepreneurs to keep their personal data private and run a professional business. As the trend towards working from home seems set to continue, we expect to see increased interest in this service."',
}

const PartnerTestimonialCard = ({
  alt,
  designation,
  logo,
  review,
  reviewer,
  textSize = 'normal',
}: PartnerTestimonialCardProps) => {
  return (
    <div className='card px-10 px-lg-20 py-14 py-lg-12 d-flex flex-column align-items-center align-items-lg-start'>
      <img
        {...generateSrcSet(logo, 330, 134)}
        alt={alt}
        loading='lazy'
        className='img-fluid object-fit-contain'
        height={134}
        width={330}
      />
      <h3 className='fw-semibold mb-4 mt-6 fs-fluid-24-34'>
        <strong>{reviewer}, </strong> <br />
        {designation}
      </h3>
      <div
        className={classNames(
          'fw-semibold color-grey5 fst-italic',
          textSize === 'normal' && 'fs-fluid-18-24',
          textSize === 'large' && 'fs-fluid-34-48 lh-111',
        )}
      >
        {review}
      </div>
    </div>
  )
}

const PartnersTestimonial: FC<Props> = ({
  annaReview,
  textSize,
  tideReview,
}) => {
  return (
    <div className='row gy-5'>
      <div className='col-12 col-lg-6'>
        <PartnerTestimonialCard
          logo='/images/logos/partners/tide-color.png'
          alt='Tide Logo'
          reviewer='George Schmidt'
          designation='CEO UK/Europe at Tide:'
          review={tideReview || ukTestimonials.tide}
          textSize={textSize}
        />
      </div>
      <div className='col-12 col-lg-6'>
        <PartnerTestimonialCard
          logo='/images/logos/partners/anna-color.png'
          alt='ANNA Logo'
          reviewer='Boris Diakonov'
          designation='Co-CEO ANNA:'
          review={annaReview || ukTestimonials.anna}
          textSize={textSize}
        />
      </div>
    </div>
  )
}

export default PartnersTestimonial
